import { createSelector } from 'reselect';

import { SELF_SERVICE } from 'constants/ExtensionConstants';
import { GOLD, PLATINUM } from 'constants/Global';
import { SELF_SERVICE_ORIGIN, SELF_SERVICE_ORIGINS } from 'constants/SelfServiceConstants';
import { getSelectedDealerId, getSelectedDealerSelfServicePack, hasExtensions } from 'selectors/dealerSelectors';

export const getRoot = state => state;

/** @returns {import('../reducer').SelfServiceReducer} */
const getState = state => state.selfServices;

export const getUI = createSelector(getState, state => state.ui);
const getData = createSelector(getState, state => state.data);

const getModel = createSelector(getUI, ui => ui.model);

export const isModelFetching = createSelector(getModel, model => model.isLoading);

export const isDownloading = createSelector(getUI, ui => ui.isDownloading);

export const getAllowedOrigins = createSelector(getSelectedDealerSelfServicePack, pack => {
  const hasRightPack = pack === GOLD || pack === PLATINUM;
  return hasRightPack
    ? SELF_SERVICE_ORIGINS
    : SELF_SERVICE_ORIGINS.filter(origin => origin !== SELF_SERVICE_ORIGIN.KIOSK);
});

export const getKioskAdminToken = createSelector(getData, ({ kioskAdminToken }) => kioskAdminToken);
export const isKioskAdminTokenFetching = createSelector(getUI, ({ isKioskAdminTokenFetching: isFetching }) => isFetching);

export const hasSelfServiceExtension = createSelector(getRoot, getSelectedDealerId, (state, dealerId) =>
  hasExtensions(state, dealerId, SELF_SERVICE));
